import { useProduct } from '@/hooks/useProduct'
import dynamic from 'next/dynamic'

const ProductImagesCarousel = dynamic(import('@csc/dls/ProductImagesCarousel'))
const formatImagesArrayForDls = (productName: string) => ({
  url_square: url,
  url_thumbnail: thumbNail,
  url_zoom: zoom,
}: {
  url_square: string,
  url_thumbnail: string,
  url_zoom: string,
}, index: number) => ({
  url,
  thumbNail,
  zoom,
  title: `Product_image_${productName}_${index}`,
})

export const ProductImage: React.FC = () => {
  const {
    product,
    variantId: selectedVariantId,
  } = useProduct()
  const selectedVariantImages = (
    product?.variants.find(({ id }) => `${selectedVariantId}` === `${id}`)?.images || []
  )

  const images = (selectedVariantImages).map(formatImagesArrayForDls(product?.name || ''))

  return (
    <ProductImagesCarousel id="pdp-main-product-image" images={images} />
  )
}

export default ProductImage
